import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from '../../context';

function SidebarIcon({isAuthenticated}) {
    const dispatch = useDispatch();
    const isSidebarOpen = useSelector((state) => state.toggle.isSidebarOpen);
    return (
        <span
            title="Toggle practice list"
            className={classNames('px-3 op-5 hoverable', {
                'd-none': !isAuthenticated,
            })}
            onClick={() =>
                dispatch(actions.toggle.toggleSidebarOpen(!isSidebarOpen))
            }>
            <FontAwesomeIcon
                className={classNames('text-dark rotate-animated', {
                    rotated: isSidebarOpen,
                })}
                icon={faAngleDoubleRight}
                size="2x"
            />
        </span>
    );
}

export default SidebarIcon;
